import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-flash-icon',
  templateUrl: './flash.svg',
  styleUrls: ['./flash-icon.component.scss'],
})
export class FlashIconComponent {
  @Input() flash: {strokeColor: '#FF7F50' | '#9d9fa6' | 'black' | 'white' | 'none', fillColor: '#FF7F50'  | '#9d9fa6' | 'black' | 'white' | 'none'} = {
    strokeColor: '#9d9fa6', fillColor: 'none'
  };
  @Input() circle: {strokeColor: '#D1433A' | 'white' | 'none', fillColor: '#D1433A' | 'white' | 'none'} = {
    strokeColor: '#D1433A', fillColor: '#D1433A'
  };
}
